import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCopy(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15.162 8.838V5.189c0-1.209-.98-2.189-2.189-2.189H5.189A2.19 2.19 0 0 0 3 5.19v7.783c0 1.209.98 2.19 2.19 2.19h3.648m2.189-6.325h7.784c1.209 0 2.189.98 2.189 2.189v7.784A2.19 2.19 0 0 1 18.81 21h-7.783a2.19 2.19 0 0 1-2.19-2.19v-7.783a2.19 2.19 0 0 1 2.19-2.19"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCopy);
export default ForwardRef;
